<template>
  <v-layout 
    class="mb-5"
    row>
    <v-flex
      xs12
      md6
      offset-md3>
      <v-toolbar
        flat
        color="white">
        <v-toolbar-title>Versionsverlauf</v-toolbar-title>
      </v-toolbar>

      <app-settings-versions-card
        v-for="(item, index) in orderedVersions"
        :key="index"
        :item="item">
      </app-settings-versions-card>
    </v-flex>
  </v-layout>
</template>



<script>
import SettingsVersionsCard        from '@/components/View_Profile/SettingsVersions_Card'

import { mapState } from 'vuex'
import { orderBy } from 'lodash'


export default {
  components: {
  // eslint-disable-next-line
    'app-settings-versions-card': SettingsVersionsCard,
  },
  computed: {
    ...mapState({
      version: state => state.version
    }),
    orderedVersions: function() {
      return orderBy(this.version.versions, 'version', 'desc')
    }
  },
  mounted() {

    this.toTop()
   
  },
  methods: {
    toTop() {
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          duration: 100,
          offset: 0,
          easing: 'easeInOutQuint'
        })
      }, 33)
    }
  
  }
}
</script>
